import React, { useState } from 'react';
import axios from 'axios';
import './Volunteer.css';

const Volunteer = () => {
        const [formData, setFormData] = useState({
            fullName: '',
            mobile: '',
            email: '',
            city: '',
            interestArea: '',
            availability: '',
            message: ''
        });

        const [errors, setErrors] = useState({
            mobile: '',
            email: ''
        });

        const [status, setStatus] = useState({
            submitting: false,
            submitted: false,
            error: false,
            message: ''
        });

        const interestAreas = [
            { value: '', label: 'Select area of interest' },
            { value: 'Environment', label: 'Environment', icon: '🌳' },
            { value: 'Education', label: 'Education', icon: '📚' },
            { value: 'Health', label: 'Health', icon: '🏥' },
            { value: 'Field Work', label: 'Field Work', icon: '🌾' },
            { value: 'Office / Digital Support', label: 'Office / Digital Support', icon: '💻' }
        ];

        const availabilityOptions = [
            { value: '', label: 'Select availability' },
            { value: 'Weekends', label: 'Weekends' },
            { value: 'Full Time', label: 'Full Time' },
            { value: 'Part Time', label: 'Part Time' }
        ];

        const isValidEmail = (email) => {
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            return emailRegex.test(email);
        };

        const isValidMobile = (mobile) => {
            const mobileRegex = /^(\+91[\-\s]?)?[6-9]\d{9}$/;
            return mobileRegex.test(mobile);
        };

        const handleChange = (e) => {
            const { name, value } = e.target;
            setFormData({...formData, [name]: value });

            if (name === 'email') setErrors({...errors, email: '' });
            if (name === 'mobile') setErrors({...errors, mobile: '' });
        };

        const validateForm = () => {
            let valid = true;
            const newErrors = { mobile: '', email: '' };

            if (!formData.mobile) {
                newErrors.mobile = 'Mobile number is required';
                valid = false;
            } else if (!isValidMobile(formData.mobile)) {
                newErrors.mobile = 'Please enter a valid Indian mobile number';
                valid = false;
            }

            if (!formData.email) {
                newErrors.email = 'Email is required';
                valid = false;
            } else if (!isValidEmail(formData.email)) {
                newErrors.email = 'Please enter a valid email address';
                valid = false;
            }

            setErrors(newErrors);
            return valid;
        };

        const handleSubmit = async(e) => {
            e.preventDefault();

            if (!validateForm()) return;

            setStatus({ submitting: true, submitted: false, error: false, message: '' });

            try {
                const response = await axios.post('http://localhost:5000/api/volunteer', formData);

                if (response.data.success) {
                    setStatus({
                        submitting: false,
                        submitted: true,
                        error: false,
                        message: response.data.message
                    });
                    setFormData({
                        fullName: '',
                        mobile: '',
                        email: '',
                        city: '',
                        interestArea: '',
                        availability: '',
                        message: ''
                    });
                }
            } catch (error) {
                console.error('Error:', error);
                setStatus({
                    submitting: false,
                    submitted: false,
                    error: true,
                    message: 'Failed to submit application. Please try again later.'
                });
            }
        };

        return ( <
                div className = "volunteer" > { /* Hero Section */ } <
                div className = "volunteer-hero" >
                <
                div className = "hero-pattern" > < /div> <
                div className = "container" >
                <
                div className = "hero-logo-wrapper" >
                <
                span className = "hero-logo-main" > VICHITRRARANYA < /span> <
                span className = "hero-logo-sub" > Foundation < /span> <
                /div> <
                h1 > 🤝Become a Volunteer < /h1> <
                p > Join us in making a difference.Your time and skills can help transform lives and protect our environment. < /p> <
                /div> <
                div className = "hero-wave" >
                <
                svg viewBox = "0 0 1440 180"
                fill = "none"
                xmlns = "http://www.w3.org/2000/svg" >
                <
                path d = "M0 180L60 157.5C120 135 240 90 360 67.5C480 45 600 45 720 56.25C840 67.5 960 90 1080 101.25C1200 112.5 1320 112.5 1380 112.5L1440 112.5V180H1380C1320 180 1200 180 1080 180C960 180 840 180 720 180C600 180 480 180 360 180C240 180 120 180 60 180H0Z"
                fill = "white" / >
                <
                /svg> <
                /div> <
                /div>

                { /* Volunteer Form Section */ } <
                div className = "volunteer-form-section" >
                <
                div className = "container" >
                <
                div className = "form-container" >
                <
                h3 className = "form-heading" > 🤝Join the Movement < /h3>

                {
                    status.submitted && ( <
                        div className = "alert success" >
                        <
                        span className = "alert-icon" > ✓ < /span> {status.message} <
                        /div>
                    )
                } {
                    status.error && ( <
                        div className = "alert error" >
                        <
                        span className = "alert-icon" > ✗ < /span> {status.message} <
                        /div>
                    )
                }

                <
                form onSubmit = { handleSubmit }
                className = "volunteer-form" > { /* Full Name */ } <
                div className = "form-group" >
                <
                label > Full Name < /label> <
                input type = "text"
                name = "fullName"
                placeholder = "Enter your full name"
                value = { formData.fullName }
                onChange = { handleChange }
                required /
                >
                <
                /div>

                { /* Mobile Number and Email - Two Columns */ } <
                div className = "form-row" >
                <
                div className = "form-group half" >
                <
                label > Mobile Number < /label> <
                input type = "tel"
                name = "mobile"
                placeholder = "Enter your mobile number"
                value = { formData.mobile }
                onChange = { handleChange }
                required className = { errors.mobile ? 'error-input' : '' }
                /> {
                    errors.mobile && < span className = "error-message" > { errors.mobile } < /span>} <
                        /div>

                    <
                    div className = "form-group half" >
                        <
                        label > Email Address < /label> <
                        input
                    type = "email"
                    name = "email"
                    placeholder = "Enter your email"
                    value = { formData.email }
                    onChange = { handleChange }
                    required
                    className = { errors.email ? 'error-input' : '' }
                    /> {
                        errors.email && < span className = "error-message" > { errors.email } < /span>} <
                            /div> <
                            /div>

                        { /* City / District */ } <
                        div className = "form-group" >
                            <
                            label > City / District < /label> <
                            input
                        type = "text"
                        name = "city"
                        placeholder = "Enter your city or district"
                        value = { formData.city }
                        onChange = { handleChange }
                        required
                            /
                            >
                            <
                            /div>

                        { /* Area of Interest */ } <
                        div className = "form-group" >
                            <
                            label > Area of Interest < /label> <
                            select
                        name = "interestArea"
                        value = { formData.interestArea }
                        onChange = { handleChange }
                        required
                        className = "interest-select" >
                            {
                                interestAreas.map((area, index) => ( <
                                    option key = { index }
                                    value = { area.value } > { area.icon ? `${area.icon} ${area.label}` : area.label } <
                                    /option>
                                ))
                            } <
                            /select> <
                            /div>

                        { /* Availability */ } <
                        div className = "form-group" >
                            <
                            label > Availability < /label> <
                            select
                        name = "availability"
                        value = { formData.availability }
                        onChange = { handleChange }
                        required
                        className = "availability-select" >
                            {
                                availabilityOptions.map((option, index) => ( <
                                    option key = { index }
                                    value = { option.value } > { option.label } < /option>
                                ))
                            } <
                            /select> <
                            /div>

                        { /* Message */ } <
                        div className = "form-group" >
                            <
                            label > Message / Why do you want to join us ? < /label> <
                                textarea
                            name = "message"
                        placeholder = "Tell us why you'd like to volunteer..."
                        rows = "4"
                        value = { formData.message }
                        onChange = { handleChange } >
                            < /textarea> <
                            /div>

                        { /* Submit Button */ } <
                        button
                        type = "submit"
                        className = "submit-btn"
                        disabled = { status.submitting } >
                            {
                                status.submitting ? ( <
                                    span > Submitting < span className = "dots" > ... < /span></span >
                                ) : ( <
                                    span > 👉Join the Movement < /span>
                                )
                            } <
                            /button> <
                            /form> <
                            /div> <
                            /div> <
                            /div> <
                            /div>
                    );
                };

                export default Volunteer;